import store from '@/store'
import network from '@/utils/network'

/**
 * Créé / met à jour une indispo agent
 * @returns {Promise<>}
 */
export const postAgencyAgentUnavailability = async ({ agent, ...unavailability }) => {
  const slugAgency = store.getters['user/agencySlug']
  const slugAgent = _.isObject(agent) ? agent.slug : agent
  const r = await network.post(`agency/${slugAgency}/agent/${slugAgent}/unavailability`, unavailability)
  return r.data
}

/**
 * Supprime une indispo
 * @returns {Promise<>}
 */
export const deleteAgencyAgentUnavailability = async ({ agent, id }) => {
  const slugAgency = store.getters['user/agencySlug']
  const slugAgent = _.isObject(agent) ? agent.slug : agent
  const r = await network.delete(`agency/${slugAgency}/agent/${slugAgent}/unavailability/${id}`)
  return r.data
}
